var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAccountBadgeFunctionDef } from '../../../../backend/features/badges/shared';
import { BadgeAccountsSelectionWizardLikeDialog } from '../../../../ui/features/badge-management/components/BadgeAccountsSelectionPanel/BadgeAccountsSelectionWizardLikeDialog';
import { AccountContext, AccountContextProvider } from '../../../../ui/features/badge-management/contexts/AccountContext';
import { BadgePreviewContext, BadgePreviewContextProvider } from '../../../../ui/features/badge-preview/contexts/BadgePreviewContext';
import { useBadgingTranslation } from '../../../../ui/hooks';
import { showCustomDialog, showErrorDialog } from '@juvare/common-web-ui/DialogHelper';
import { showAlertSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { useTypedPlatformFunction } from '@juvare/platform-sdk-react/ui/features/typed-platform-functions';
import React from 'react';
export const useAddAccountBadgeAction = ({ badgeId, accountBadgesAll, onActionCompleted }) => {
    const { t } = useBadgingTranslation();
    const createAccountBadgePlatformFn = useTypedPlatformFunction(createAccountBadgeFunctionDef);
    const handleAccountBadgesAdd = React.useCallback((selectedAccounts) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield createAccountBadgePlatformFn({
                badgeId,
                accounts: selectedAccounts,
            });
            showAlertSnackbar({
                horizontalPosition: 'center',
                type: 'success',
                verticalPosition: 'bottom',
                autoHideDuration: 2000,
                message: t('badges.badgeDetails.accountBadgeTable.addAccountSuccess'),
            });
            onActionCompleted();
        }
        catch (_a) {
            showErrorDialog({ title: t('badges.badgeDetails.accountBadgeTable.addAccountFailed') });
        }
    }), [createAccountBadgePlatformFn, t, badgeId, onActionCompleted]);
    const excludedAccountIds = accountBadgesAll.map((accountBadge) => accountBadge.accountId);
    const accountContext = React.useContext(AccountContext);
    const badgePreviewContext = React.useContext(BadgePreviewContext);
    const handleAddAccount = () => {
        showCustomDialog({
            fullScreen: true,
            content: (close) => {
                return (React.createElement(AccountContextProvider, Object.assign({}, accountContext),
                    React.createElement(BadgePreviewContextProvider, Object.assign({}, badgePreviewContext),
                        React.createElement(BadgeAccountsSelectionWizardLikeDialog, { initialStorageAccountFilters: [
                                {
                                    op: 'not-in',
                                    id: excludedAccountIds,
                                },
                            ], showAccountSelectDialogInitially: true, badgeId: badgeId, onSave: handleAccountBadgesAdd, onClose: close }))));
            },
            onEscapeKeyDown: (close) => close(),
        });
    };
    return {
        handleAddAccount,
    };
};
